import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import { getPartLocal } from "Stores/actions";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import { Checkbox, DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { partLocalList } from "Constants/TableColumns";
import NewProduct from "./components/New/NewProduct";
import { useTranslation } from "react-i18next";
import CopyProduct from "./components/Copy/CopyProduct";
import DeleteProduct from "./components/Delete/DeleteProduct";
import EditProduct from "./components/Edit/EditProduct";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function ProductList({ prow }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [tblSelectedRow, setTblSelectedRow] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [tblPagination, setTblPagination] = useState({ Limit: 5, Page: 1, Total: 0 });
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialog = () => {
    setOpenDialog(!openDialog);
  }

  const onEnter = async () => {
    setSearch("");
    setTblSelectedRow([]);
    await getData();
  }

  const getData = async (_page, search = null) => {
    setLoading(true);
    const params = {
      KeyUser: read("userKey"),
      KeyGroup: read("groupKey"),
      Limit: 5,
      Page: _page ? _page : tblPagination.Page ? tblPagination.Page : 1,
      idRangeTechnicalFitting: prow.Id,
      ...search
    };
    const result = await dispatch(getPartLocal(params));
    if(result) {
      setTblData(result.list.map((item, index) => {
        return { num: (((result.pagination.Page - 1) * 5) + index + 1), ...item }
      }));
      setTblPagination(result.pagination);
    }
    setLoading(false);
  }

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    await getData(1, { name: search });
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    await getData(1);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    setLoading(true);
    if (type === "pagination") {
      try {
        await getData(page);
        setTblPagination({
          ...tblPagination,
          Page: page
        })
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  }

  const refresh_list = async () => {
    const page = Math.ceil(tblPagination.Total / 5);
    await getData(page);
    setTblPagination({
      ...tblPagination,
      Page: page
    })
  }

  const selectRow = {
    mode: "checkbox",
    selected: tblSelectedRow,
    clickToSelect: false,
    onSelect: (row, isSelect) => {
      if(isSelect) setTblSelectedRow(tblSelectedRow.concat(row.Id));
      else setTblSelectedRow(tblSelectedRow.filter(i => i !== row.Id));
    },
    onSelectAll: (isSelect, rows) => {
      const ids = rows.map(i => { return i.Id });
      if (isSelect) setTblSelectedRow([...new Set(tblSelectedRow.concat(ids))]);
      else setTblSelectedRow(tblSelectedRow.filter(i => !(new Set(ids)).has(i)));
    },
    classes: "selection-row",
    selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
      <Checkbox
        className="selectRadio"
        ref={i => { if(i) i.indeterminate = indeterminate; }}
        { ...rest }
        // checkedIcon={ <ReactSVG src={checkBoxCheckedIcon} /> }
        // icon={ <ReactSVG src={checkBoxIcon} /> }
      />
    ),
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Checkbox
          className="selectRadio"
          color="default"
          // size="small"
          checked={checked}
          disabled={disabled}
          // checkedIcon={ <ReactSVG src={checkBoxCheckedIcon} /> }
          // icon={ <ReactSVG src={checkBoxIcon} /> }
        />
      );
    },
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="yaraghProductList" />}
        icon={<Icons.ListUl size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={prow.IsG && read("StypeU") !== "1"}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{
          onEnter: onEnter,
        }}
        fullWidth
        maxWidth="md"
      >
        <div>
          <BackDropLoading loading={loading} />
          <div className="dialogHeader">
            <p>{`${t('yaraghProductList')} - ${prow.Code}`}</p>
          </div>
          <DialogContent id="content-dialog-manager">
            <NewProduct 
              prow={prow}
              onAddNew={() => refresh_list()}
            />
            <Grid container spacing={2} className="box-border overflow-hidden mt-4">
              <Grid item xs={12} className="text-center py-2" style={{backgroundColor: '#E4E8E8'}}>
                <strong>{t('yaraghProductList')}</strong>
              </Grid>
              {
                <Grid container>
                  <Grid item lg={4} md={6} xs={12} className="mx-2 mb-2">
                    <Input
                      setValue={setValue.bind(this)}
                      name="search"
                      value={search}
                      placeholder={t('nameSearch')}
                      type="search"
                      onSearch={onSearch}
                      onClearSearch={onClearSearch}
                    />
                  </Grid>
                  <RemoteTable
                    data={tblData}
                    keyField="Id"
                    selectRow={selectRow}
                    selection={tblSelectedRow}
                    columns={[
                      ...partLocalList,
                      {
                        dataField: "edit",
                        text: "",
                        isDummyField: true,
                        formatter: (cell, row) => <EditProduct
                          row={row}
                          idRangeTechnicalFitting={prow.Id}
                          onClick={() => getData()}
                        />,
                        align: "center",
                        classes: "normal",
                        headerClasses: "action",
                        editable: false,
                      },{
                        dataField: "delete",
                        text: "",
                        isDummyField: true,
                        formatter: (cell, row) => <DeleteProduct
                          row={row}
                          onClick={() => getData()}
                        />,
                        align: "center",
                        classes: "normal",
                        headerClasses: "action",
                        editable: false,
                      }
                    ]}
                    loading={loading}
                    page={tblPagination.Page}
                    sizePerPage={5}
                    sizePerPageList={[{ text: "5",value: 5 }]}
                    totalSize={tblPagination.Total}
                    onTableChange={onTableChange}
                    noTitle
                  />
                </Grid>
              }
            </Grid>
          </DialogContent>
          <DialogActions>
            {
              tblSelectedRow.length !== 0 &&
              <CopyProduct
                prow={prow}
                products={tblSelectedRow}
                onCopy={() => setTblSelectedRow([])}
              />
            }
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </div>
      </Dialog>
    </>
  );
}

export default ProductList;
